module.exports = __webpack_public_path__ + "8afb6c6f6577cf7c448089ddf1520ae6.svg";